/**
 * Cookied Cookie Banner
 * Lightweight, GDPR-compliant cookie consent solution
 * 
 * Usage:
 * <script async src="https://cdn.cookied.io/banner.js" data-api-key="ck_xxx"></script>
 */

import { CookiedBanner } from './banner';
import type { CookiedConfig } from './types';

// Auto-initialize when the script loads
(function() {
  // Find the script tag to get the API key
  const scripts = document.getElementsByTagName('script');
  let apiKey = '';
  let config: Partial<CookiedConfig> = {};

  for (let i = scripts.length - 1; i >= 0; i--) {
    const script = scripts[i];
    if (script.src && script.src.includes('banner.js')) {
      apiKey = script.getAttribute('data-api-key') || '';
      
      // Optional API endpoint override
      const apiEndpoint = script.getAttribute('data-api-endpoint');
      if (apiEndpoint) {
        config.apiEndpoint = apiEndpoint;
      }

      const ingestEndpoint = script.getAttribute('data-ingest-endpoint');
      if (ingestEndpoint) {
        config.ingestEndpoint = ingestEndpoint;
      }
      
      // Optional inline config
      const inlineConfig = script.getAttribute('data-config');
      if (inlineConfig) {
        try {
          config = { ...config, ...JSON.parse(inlineConfig) };
        } catch (e) {
          console.warn('[Cookied] Invalid inline config');
        }
      }
      break;
    }
  }

  if (!apiKey) {
    console.error('[Cookied] API key not found. Add data-api-key attribute to the script tag.');
    return;
  }

  // Initialize the banner
  const banner = new CookiedBanner();
  
  // Make it available globally
  (window as any).Cookied = banner;
  (window as any).CookiedBanner = CookiedBanner;

  // Auto-init when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => banner.init(apiKey, config));
  } else {
    banner.init(apiKey, config);
  }
})();

// Export for module usage
export { CookiedBanner } from './banner';
export type { CookiedConfig, ConsentState, BannerTheme } from './types';

